module.exports = __webpack_public_path__ + "img/csr_swiper_01_05.2d73fb8d.jpg";